import React from 'react'
import Typography from '@material-ui/core/Typography'
import Card from '@material-ui/core/Card'
import CardContent from '@material-ui/core/CardContent'
import Skeleton from '@material-ui/lab/Skeleton'
import clsx from 'clsx'

import { useChatStyles } from './chat.styles'

type ChatMessageSkeletonProps = {
  position?: 'start' | 'end'
}

export const ChatMessageSkeleton = (props: ChatMessageSkeletonProps) => {
  const classes = useChatStyles()

  return (
    <div
      className={clsx(classes.message, {
        [classes.messageReverse]: props.position === 'end'
      })}
    >
      <Skeleton variant="circle" className={classes.avatar} />
      <Card className={classes.messageCard}>
        <CardContent className={classes.messageCardContent}>
          <Typography variant="body2" gutterBottom>
            <Skeleton width={250} />
          </Typography>
          <Typography
            align="right"
            variant="caption"
            component="div"
            color="textSecondary"
          >
            <Skeleton width={150} />
          </Typography>
        </CardContent>
      </Card>
    </div>
  )
}
